export default __webpack_public_path__ + "static/media/wa-background.7414bae8.png";